import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'
import InputFieldWithPrefix from 'Pods/Shared/InputFieldWithPrefix'
import { RuleRunner, run } from 'Pods/Shared/RuleRunner'
import {
  required, decimalPrice, min, notLowerThan50Percent,
} from 'Pods/Shared/Rules/Rules'

class OfferPriceModal extends React.Component {
  constructor() {
    super()

    this.state = {
      isDisabledSubmit: false,
      showErrors: false,
      price: '',
      message: '',
      validationErrors: {},
    }

    this.onModalClose = this.onModalClose.bind(this)
    this.sendOffer = this.sendOffer.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
    this.fieldValidations = this.fieldValidations.bind(this)
  }

  componentWillMount() {
    this.setState({ validationErrors: run(this.state, this.fieldValidations()) })
  }

  fieldValidations() {
    return [
      RuleRunner('price', 'Price', required, decimalPrice, min(2), notLowerThan50Percent(this.props.itemPrice)),
      RuleRunner('message', 'Message', required),
    ]
  }

  sendOffer(e) {
    e.preventDefault()

    this.setState({ isDisabledSubmit: true, showErrors: true })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length === 0) {
      axios.post(
        '/api/internal/price_offers',
        {
          offer: { price: this.state.price, item_id: this.props.itemId, item_type: 'Item' },
          conversation: { message: this.state.message },
        }
      ).then(this.onSubmitSuccess).catch(this.onSubmitFailure)
    } else {
      this.setState({ isDisabledSubmit: false })
    }
  }

  onSubmitSuccess() {
    this.setState({ isDisabledSubmit: false, price: null, message: '' })
    App.events.publish('app:notification:flash:success', 'Thank you, your offer has been sent!')
    this.props.closeModal()
  }

  onSubmitFailure(error) {
    App.events.publish(
      'app:notification:flash:error',
      Object.values(error.response.data.errors.custom_errors).join(', ')
    )

    this.setState({ isDisabledSubmit: false })
  }

  onModalClose(e) {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal(e)
  }

  handleInputChange(e) {
    const newState = this.state

    newState[e.target.name] = e.target.value
    newState.validationErrors = run(newState, this.fieldValidations())

    this.setState(newState)
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--product overlay-modal--jobs">
            <h2 className="heading-18">Make offer</h2>
            <div className="modal__description">
              <p>Enter the price at which you would be willing to purchase this product.</p>
            </div>
            <form onSubmit={(e) => this.sendOffer(e)}>
              <InputFieldWithPrefix
                id="price"
                name="price"
                label="Price"
                type="number"
                prefix="$"
                required
                value={this.state.price}
                formClassName="form-group-grey form-group--price"
                inputClassName="form-control-grey"
                onChange={this.handleInputChange}
                errorText={this.errorFor('price')}
                showError={this.state.showErrors}
                errorTooltipPos="bottom"
              />
              <TextareaField
                id="message"
                name="message"
                label="Message"
                value={this.state.message}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={this.handleInputChange}
                placeholder="Type here..."
                errorText={this.errorFor('message')}
                showError={this.state.showErrors}
              />
              <div className="footer u-text-right u-mt10">
                <button className="cgt-button cgt-button--secondary cgt-button--medium" onClick={this.onModalClose}>
                  <span>Cancel</span>
                </button>
                <button
                  type="submit"
                  className="cgt-button cgt-button--primary cgt-button--medium cgt-ml-10"
                  disabled={this.state.isDisabledSubmit}
                >
                  <span>Make offer</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    )
  }
}

OfferPriceModal.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemPrice: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool,
}

OfferPriceModal.defaultProps = {
  modalIsOpen: false,
}

export default OfferPriceModal
